import { LOCATION_INITIALIZED } from '@angular/common';
import { Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageEnum } from '../enum/language';
import { LANGUAGE_PREF_KEY } from './language.service';

function toLocale(language: LanguageEnum): string {
  return language === LanguageEnum.French ? 'fr_CA' : 'en_CA';
}

export function ApplicationInitializerFactory(translate: TranslateService, injector: Injector) {
  return async () => {
    await injector.get(LOCATION_INITIALIZED, Promise.resolve(null));

    const currentLocalStorage = JSON.parse(localStorage.getItem('ecklerUser'));
    const platformLocales = ['fr_CA', 'en_CA'];

    let defaultLang: string;

    if (currentLocalStorage?.language !== undefined) {
      // Authenticated user: use their confirmed member-level language
      defaultLang = toLocale(currentLocalStorage.language);
    } else {
      // Unauthenticated: use persisted preference from a previous session so
      // the login page loads immediately in the correct language (no flash).
      const persisted = localStorage.getItem(LANGUAGE_PREF_KEY);
      defaultLang = toLocale(parseInt(persisted, 10));
      if (persisted !== null) {
        console.log('[Language] Applying persisted preference for unauthenticated load:', defaultLang);
      }
    }

    translate.addLangs(platformLocales);
    translate.setDefaultLang(defaultLang);
    translate.use(defaultLang);
  };
}
